import { env } from '@/lib/env';

/**
 * Dashboard BFF base (sap-jobs, sod-rules, business-value, …).
 *
 * When REACT_APP_DASHBOARD_API_URL is set (Job Failure local), sap-jobs reads hit
 * local dashboardapi (e.g. :8012) while REACT_APP_BACKEND_URL can remain the UAT2
 * gateway for authentication (/api/auth/*).
 */
export function getDashboardApiBase() {
  const explicit = (env('REACT_APP_DASHBOARD_API_URL') || '').replace(/\/$/, '');
  if (explicit) {
    if (explicit.includes('/api/dashboard')) {
      return explicit;
    }
    return `${explicit}/api/dashboard`;
  }

  const backend = (env('REACT_APP_BACKEND_URL') || '').replace(/\/$/, '');
  if (!backend) {
    return '';
  }
  if (backend.endsWith('/backend')) {
    return `${backend}/api/dashboard`;
  }
  if (backend.includes('127.0.0.1:8012') || backend.includes('localhost:8012')) {
    return `${backend}/api/dashboard`;
  }
  return `${backend}/api/dashboard`;
}

export function getSapJobsApiRoot() {
  const base = getDashboardApiBase();
  return base ? `${base}/sap-jobs` : '';
}
